import { Box, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import ModalComponent from "../../components/ModalComponent";
import { useZoneForm } from "../../hooks/pages/useZoneForm";

export default function ZoneCreate({ open, setOpen, zone, getList }) {
  const { initialValues, validationSchema, onSubmit } = useZoneForm({
    zone,
    getZones: getList,
    handleClose: setOpen
  });

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          isSubmitting
        }) => {
          return (
            <Form id="form-zone">
              <ModalComponent
                open={open}
                title="Dados do Zoneamento"
                maxWidth={"sm"}
                handleOpen={setOpen}
                buttonOkType={"submit"}
                disabledClick={isSubmitting}
                buttonForm="form-zone"
              >
                <TextField
                  margin="normal"
                  variant="filled"
                  fullWidth
                  label="Nome"
                  name="Nome"
                  value={values.Nome}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                  onChange={handleChange}
                  helperText={touched.Nome && errors.Nome}
                  error={Boolean(touched.Nome && errors.Nome)}
                />
                <TextField
                  margin="normal"
                  variant="filled"
                  fullWidth
                  id="Classificacao"
                  label="Classificação"
                  name="Classificacao"
                  value={values.Classificacao}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                  onChange={handleChange}
                  helperText={touched.Classificacao && errors.Classificacao}
                  error={Boolean(touched.Classificacao && errors.Classificacao)}
                />
              </ModalComponent>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
}
